module.exports = __webpack_public_path__ + "static/media/twitter-icon.cf381cf3.svg";